import {CommonResponseModel, PlantDto, PlantIdReq} from "@project-management-system/shared-models";
  import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
  
  export class PlantsService extends CommonAxiosService {
    private URL = "/plants";
  
    async createPlant(payload: PlantDto): Promise<CommonResponseModel> {
      return this.axiosPostCall(this.URL + "/createPlant", payload);
    }
  
    async updatePlant(dto: PlantDto): Promise<CommonResponseModel> {
      return this.axiosPostCall(this.URL + "/updatePlant", dto);
    }
  
    async getAllPlants(): Promise<CommonResponseModel> {
      // console.log("GetAllPlants")
      return this.axiosPostCall(this.URL + "/getAllPlants");
    }
  
    async getActiveAllPlants(): Promise<CommonResponseModel> {
      return this.axiosPostCall(this.URL + "/getActiveAllPlants")
  }
  
    async activateOrDeactivatePlant(payload: PlantDto): Promise<CommonResponseModel> {
      return this.axiosPostCall(this.URL + "/activateOrDeactivatePlant", payload);
    }

    async getPlantById(payload: PlantIdReq): Promise<CommonResponseModel> {
      return this.axiosPostCall(this.URL + "/getPlantById", payload);
    }
  }
  